"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizes = void 0;
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../../mantine-theme/src");
exports.sizes = {
    xs: 120,
    sm: 160,
    md: 200,
    lg: 240,
    xl: 300,
};
exports.default = react_jss_1.createUseStyles({
    menu: function (_a) {
        var theme = _a.theme, size = _a.size;
        return ({
            position: 'absolute',
            width: theme_1.getSizeValue({ size: size, sizes: exports.sizes }),
            overflow: 'hidden',
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.white,
            border: "1px solid " + (theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.colors.gray[2]),
            paddingTop: theme.spacing.xs / 2,
            paddingBottom: theme.spacing.xs / 2,
        });
    },
    hr: function (_a) {
        var theme = _a.theme;
        return ({
            borderTopColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2],
            marginTop: theme.spacing.xs / 2,
            marginBottom: theme.spacing.xs / 2,
        });
    },
}, { link: true });
